import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { DevicesOsUpdateStatesEffects } from './devices-os-update-status.effects';
import { DevicesOsUpdateStatesReducer, DevicesOsUpdateStatesFeatureKey } from './devices-os-update-status.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(DevicesOsUpdateStatesFeatureKey, DevicesOsUpdateStatesReducer),
    EffectsModule.forFeature([DevicesOsUpdateStatesEffects]),
  ],
  providers: [],
})
export class DevicesOsUpdateStatusesStoreModule {}
